import type { TOC } from '@ember/component/template-only';
import SettingsHotelAccessFormsFormUserEdit from 'lumen/components/settings/hotel-access/forms/form-user-edit';
import type DestinationSettingsHotelsEditController from 'lumen/controllers/destination/settings/hotels/edit';

interface DestinationSettingsHotelsEditSignature {
  Args: {
    controller: DestinationSettingsHotelsEditController;
    model: unknown;
  };
}

<template>
  <SettingsHotelAccessFormsFormUserEdit
    @changeHotelSearch={{@controller.changeHotelSearch}}
    @editText={{@controller.editText}}
    {{! @glint-expect-error: Incorrect type }}
    @hotelText={{@controller.hotelText}}
    @model={{@controller.model}}
    @redirectOnClose={{@controller.redirectOnClose}}
    @refreshData={{@controller.refreshData}}
    @sortResults={{@controller.sortResults}}
    @userId={{@controller.userId}}
  />
</template> satisfies TOC<DestinationSettingsHotelsEditSignature>;
